import React, { Component } from 'react';
import Header from './../../Header';
import { Link, Redirect } from "react-router-dom";
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Pagination from "react-js-pagination";
import AutoComplete from 'material-ui/AutoComplete';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
const dataSourceConfig = {
    text: 'title',
    value: 'id',
    };
class Attendance extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        var now = new Date();
        var currentYear = now.getFullYear();
        var d = new Date();
        var currentmonth = d.getMonth();
        this.state = {
            owner: has_local_data ? localdata.user_id : '',
            hrattendance: [],
            owners: [],
            userAuthKey: has_local_data ? localdata.user_key : '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            user_name: has_local_data ? localdata.user_name : '',
            loading: 1,
            isLoadMore: 1,
             year:[],
             years:currentYear,
             month:[],
             months:currentmonth,
             activePage: 1,
            item_count: '',
            isLoadMore: 1,
            loading: 1,
            search: [],
            searchText1:has_local_data ? localdata.user_name : '',
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.ownerChange = this.ownerChange.bind(this);
        this.yearchange = this.yearchange.bind(this);
        this.monthchange = this.monthchange.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }
    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }


    handlePageChange(pageNumber = 1) {
        const fd = new FormData;
        fd.append('owner', JSON.stringify(this.state.owner));
        fd.append('years', JSON.stringify(this.state.years));
        fd.append('months', JSON.stringify(this.state.months));
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/HrmanagementRest/ListAttendance/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey+ '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                
                this.setState({
                    hrattendance: findresponse.hrattendance,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count
                })
            })
    }
     ListER(page = 1) {
        const fd = new FormData;
        fd.append('owner', JSON.stringify(this.state.owner));
        fd.append('years', JSON.stringify(this.state.years));
        fd.append('months', JSON.stringify(this.state.months));
        document.getElementById('loader-new').classList.remove("hidden");
        document.getElementById('list_check').classList.add("hidden");
        fetch(this.state.apiUrl + '/HrmanagementRest/ListAttendance/page/'+ page +'/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                console.log(findresponse.item_count)
                document.getElementById('loader-new').classList.add("hidden");
                document.getElementById('list_check').classList.remove("hidden");
                this.setState({
                    loading: 0,
                    hrattendance: findresponse.hrattendance,
                    //owners: findresponse.owners,
                    isLoadMore: 1,
                    year:findresponse.year,
                    month:findresponse.month,
                    total_hour:findresponse.total_hour,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    hr_permission:findresponse.hr_permission
                })
            })
    }
    
    getUserRows() {
        return (
            <div>
                <div class="loader-new" id="loader-new"></div>
                <div class="list_check hidden" id="list_check">
                    <div class="tickets hidden-sm">
                        <ul class="tickets_head">
                            <li class="intra_col_20 padding_left_12">Employee Name</li>
                            <li class="intra_col_15">Date</li>
                            <li class="intra_col_15" >In Time</li>
                            <li class="intra_col_15">Out Time</li>
                            <li class="intra_col_20">Total Time in Office Hour</li>
                           {this.state.hr_permission=='yes'?<li class="intra_col_15">Total Office Hours</li>:''} 
                        </ul>
                        {
                            this.state.hrattendance.map((value, key) =>
                            <ul class="tickets_number">
                                <li class="intra_col_20 padding_left_12"><Link key={key} to={`/viewEmployee/${value.user_emp_id}`} name={"max"}>{value.Emp_Name}</Link></li>
                                <li class="intra_col_15">{value.Attendance_Date}</li>
                                <li class="intra_col_15">{value.In_Time?value.In_Time:'--'}</li>
                                <li class="intra_col_15"> {value.Out_Time?value.Out_Time:'--'}</li>
                                <li class="intra_col_20"> {value.out_time_end?value.out_time_end:'--'}</li>
                                {this.state.hr_permission=='yes'?<li class="intra_col_15 text-inded">{value.Duration}</li>:''} 
                            </ul>
                                )
                        }
                   </div>
                    <div class="tickets_mob er_list hidden-md">
                    <ul class="tickets_head">
                    <li class="intra_col_20 padding_left_12">Employee Name</li>
                    <li class="intra_col_15">Date</li>
                    <li class="intra_col_15" >In Time</li>
                    <li class="intra_col_15">Out Time</li>
                    <li class="intra_col_20">Total Time in Office Hour</li>
                   {this.state.hr_permission=='yes'?<li class="intra_col_15">Total Office Hours</li>:''} 
                </ul>
                {
                    this.state.hrattendance.map((value, key) =>
                    <ul class="tickets_number">
                        <li class="intra_col_20 padding_left_12"><Link key={key} to={`/viewEmployee/${value.user_emp_id}`} name={"max"}>{value.Emp_Name}</Link></li>
                        <li class="intra_col_15">{value.Attendance_Date}</li>
                        <li class="intra_col_15">{value.In_Time?value.In_Time:'--'}</li>
                        <li class="intra_col_15"> {value.Out_Time?value.Out_Time:'--'}</li>
                        <li class="intra_col_20"> {value.out_time_end?value.out_time_end:'--'}</li>
                        {this.state.hr_permission=='yes'?<li class="intra_col_15 text-inded">{value.Duration}</li>:''} 
                    </ul>
                        )
                }
                     </div>
                     {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={31}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                    {/* {this.loadMorecount()} */}
                </div>
            </div>
        )
    }
    ownerChange(event) {
        this.setState({
        owner: event.target.value,
          }, function () {
        this.ListER();
        });
        }
        yearchange(event) {
            this.setState({
            years: event.target.value,
            activePage: 1,
              }, function () {
             this.ListER();
            });
        }
        monthchange(event) {
            this.setState({
            months: event.target.value,
            activePage: 1,
              }, function () {
            this.ListER();
            });
        }
        getManager(searchText1 = '') {
            fetch(this.state.apiUrl + '/ErRest/getAssignTo/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText1, {
                    method: 'POST',
                    dataType: 'json',
                    body: JSON.stringify(this.state),
                })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.setState({
                        search: findresponse.assign_to,
                        errorText1: '',
                        errorText2:''
                        })
                    } else {
                        this.setState({ errorText1: findresponse.msg,errorText2: findresponse.msg })
                    }
                })
        }
        handleUpdateInput_manager = (searchText1) => {
            if(typeof searchText1 !== "string"){
                //check autocomplete is blank or having value?if not having value make it blank
                if(this.state.user_name){
                    searchText1= this.state.user_name;
                }else{
                    searchText1='';
                }
            }
            if(searchText1 == ""){ 
                this.setState({
                    user_name: ""
                })
            }
            this.setState({
                searchText1: searchText1,
            });
            //console.log(searchText1);
             this.getManager(searchText1);
        };
        onNewRequest_manager(chosenRequest, index) {
			//console.log('onNewRequest', chosenRequest, index);
				this.setState({
                    owner: chosenRequest.id,
                    user_name: chosenRequest.title,
                    activePage: 1,
                }, function () {
                this.ListER();
					//assign_to_title: chosenRequest.title
				})
				//console.log(this.state.owner);
			}

    componentDidMount() {
        var obj = this;
        document.title = "Intranet | Attendance System";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }

        //End
        setTimeout(function () {
            obj.ListER();
        }, 100);
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Attendance" brecum_page="Attendance" />
                <div class="right_col">
                <div class="intranet_body">
                <div class="title mob hidden-sm">
                    <span>Attendance</span>
                </div>
                        <div id="exTab1" class="container">
                           <div class="tab-content er_content clearfix">
                                <div class="tab-pane active" id="Leads">
                                    <div class="top-row m_t_20 snipet_bro">
                                     <div class="er_box">
                                            <div class="form-horizontal er_cal_icon" action="/action_page.php">
                                                <div class="col-sm-4 col-xs-12">
                                            <div class="filter" name="manager">
                                                <MuiThemeProvider muiTheme={getMuiTheme()} class="form-control">
                                                <AutoComplete
                                                    onUpdateInput={this.handleUpdateInput_manager}
                                                    onNewRequest={ this.onNewRequest_manager.bind(this) }
                                                    onClick={this.handleUpdateInput_manager}
                                                    fullWidth={true}
                                                    placeholder="Search Employee or Group name"
                                                    filter={AutoComplete.caseInsensitiveFilter}
                                                    dataSource={this.state.search}
                                                    dataSourceConfig={dataSourceConfig}
                                                    errorStyle={{ bottom: 0 }}
                                                    errorText={this.state.errorText1}
                                                    maxSearchResults={500}
                                                    className="ticket_search_box"
                                                    searchText={this.state.searchText1}
                                                    openOnFocus = {true}
                                                    menuStyle = {{maxHeight: '160px'}}
                                                />
                                            </MuiThemeProvider>
                                            </div>
                                                </div>
                                                <div class="col-sm-4 col-xs-12">
                                                    <div class="filter">
                                                    <select  id="years" class="form-control" name="years" value={this.state.years} onChange={this.yearchange}>
                                                       {
                                                            this.state.year.map((dynamicData, key) =>
                                                        <option value={dynamicData.value}>{dynamicData.value}</option>
                                                                    )
                                                        }
                                                    </select>
                                                    <i class="fal fa-angle-down"></i>
                                                </div>
                                                </div>
                                                <div class="col-sm-4 col-xs-12">
                                                  <div class="filter">
                                                    <select  id="months" class="form-control" name="months" value={this.state.months} onChange={this.monthchange}>
                                                        {
                                                            this.state.month.map((dynamicData, key) =>
                                                        <option value={dynamicData.key}>{dynamicData.value}</option>
                                                                    )
                                                        }
                                                    </select>
                                                    <i class="fal fa-angle-down"></i>
                                                </div>
                                                </div>
                                                    </div>
                                                </div>
                                            </div>
                                    {this.getUserRows()}
                                </div>
                            </div>
                        </div>
                   </div>
                </div>
            </div>
        );
    }

}
export default Attendance;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/Attendance.js